import useLoginStore from '@stores/login/loginStore';
import {
  getIsRegistered,
  getLoginMethod,
  getOtpOrEmailResponse
} from '@stores/selectors/login';
import { useLocalLoginInfo } from '@cont/Login/Context/LoginLocalInfo';

import constants, {
  LOGIN_METHOD_EMAIL_OTP,
  LOGIN_METHOD_PHONE_OTP
} from '../../constants';
import useIsOutsideIndiaFlow from './useIsOutsideIndiaFlow';

const useLoginStepFlags = () => {
  const { step, loginType, accountType, showOtpField, country } =
    useLocalLoginInfo();
  const { IsNewLoginModal } = useLocalLoginInfo();
  const loginMethod = useLoginStore(getLoginMethod);
  const isRegistered = useLoginStore(getIsRegistered);
  const otpOrEmailResponse = useLoginStore(getOtpOrEmailResponse);
  const isOutsideIndiaFlow = useIsOutsideIndiaFlow();

  const isPartialUserStep = [
    constants.ENTER_OTP_UNREGISTERED_USER_STEP,
    constants.UPDATE_PARTIAL_USER_DETAILS_STEP
  ].includes(step);
  const showOutsideIndiaRegistrationProcess =
    isOutsideIndiaFlow &&
    loginType === constants.LOGIN_TYPE_EMAIL &&
    accountType === constants.ACCOUNT_TYPE_SIGNUP &&
    !isRegistered;
  const showFirstStep = step === constants.ENTER_NUMBER_STEP && !showOtpField;
  const showAgeStep = step === constants.CONFIRM_AGE && !!country;
  const showPhoneOTPStep =
    (step === constants.ENTER_OTP_STEP &&
      loginMethod !== LOGIN_METHOD_EMAIL_OTP) ||
    (isPartialUserStep && loginMethod === LOGIN_METHOD_PHONE_OTP) ||
    showOtpField;
  const showEmailOTPStep =
    constants.ENTER_OTP_STEP && loginMethod === LOGIN_METHOD_EMAIL_OTP;
  const showEnterPasswordStep =
    otpOrEmailResponse && step === constants.ENTER_PASSWORD_STEP;
  const showEmailStep =
    accountType === constants.ACCOUNT_TYPE_LOGIN &&
    loginType === constants.LOGIN_TYPE_EMAIL;
  const showUpdateDetailsStep =
    step === constants.UPDATE_PARTIAL_USER_DETAILS_STEP &&
    IsNewLoginModal &&
    loginMethod === LOGIN_METHOD_PHONE_OTP;

  return {
    showOutsideIndiaRegistrationProcess,
    showFirstStep,
    showAgeStep,
    showPhoneOTPStep,
    showEmailOTPStep,
    showEnterPasswordStep,
    showEmailStep,
    showUpdateDetailsStep
  };
};

export default useLoginStepFlags;
